import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home.vue'

Vue.use(Router)

export default new Router({
  // mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('@/views/www/Home.vue')
    },
    {
      path: '/startwithcode',
      name: '招待コードから開始する',
      component: () => import('@/views/www/StartWithCode.vue')
    }
  ]
})
